import Marionette from "backbone.marionette";
import sideBarTpl from "views/navbar/sidebarView.ejs";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette
    .View
    .extend({
        initialize: function() {


            //When options section change inside userInfo, redraw menu
            this
                .listenTo(S.userInfo, "change:options", function() {
                    this.render();
                    // Reactivate LTE menu
                    $('[data-widget="tree"]').tree();


                }.bind(this));
        },
        template: sideBarTpl,
        render: function() {

            this
                .$el
                .html(this.template({ options: S.userInfo.attributes.options, lang: S.userInfo.attributes.lang }));
        }

    });


//////////////////
// WEBPACK FOOTER
// ./app/views/navbar/sidebarView.js
// module id = 198
// module chunks = 0